import { Component, OnInit } from "@angular/core";
import {
  AlertController,
  ModalController,
  LoadingController,
  ToastController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserProvider } from "src/app/services/user/user";
import { ContribuicoesMinhasParcelasPage } from "../../contribuicoes-minhas-parcelas/contribuicoes-minhas-parcelas.page";
import { ContribuicoesProvider } from "src/app/services/contribuicoes/contribuicoes";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { MoneyPipe } from "src/app/pipes/money/money";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
@Component({
  selector: "app-contribuicoes-meus-planos",
  templateUrl: "./contribuicoes-meus-planos.page.html",
  styleUrls: ["./contribuicoes-meus-planos.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
    MoneyPipe,
    LoadingSpinnerComponent,
  ],
})
export class ContribuicoesMeusPlanosPage implements OnInit {
  carregado: boolean = false;
  planos: any = [];
  loaded = false;

  constructor(
    public modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private translate: TranslateService,
    public userProvider: UserProvider,
    public loadingController: LoadingController,
    public alertCtrl: AlertController,
    public contribuicoesController: ContribuicoesProvider
  ) {
    this.load();
  }

  ngOnInit() {}

  atualizarParcelas(plano: any) {
    if (Array.isArray(plano.parcelas)) {
      const pagas = plano.parcelas.filter((p: any) => p.pago === '1').length;
      const faltantes = plano.parcelas.length - pagas;

      plano.parcelasPagas = pagas;
      plano.parcelasFaltantes = plano.recorrente === '1' ? 'recorrente' : faltantes;
    } else {
      plano.parcelasPagas = 0;
      plano.parcelasFaltantes = plano.recorrente === '1' ? 'recorrente' : 0;
    }
  }

  load() {
    this.contribuicoesController.getMinhasContribuicoes().subscribe({
      next: (data) => {
        this.planos = data.planos;

        this.planos.forEach((plano: any) => {
          this.atualizarParcelas(plano);
        });

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro:", err);
        this.loaded = true;
      },
    });
  }


  async cancelar(idPlanoContribuicaoPessoa: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant(
        "Deseja realmente cancelar esse plano de contribuição?"
      ),
      buttons: [
        {
          text: this.translate.instant("Não"),
          handler: () => {},
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.contribuicoesController
              .cancelarPlanoContribuicao(idPlanoContribuicaoPessoa)
              .subscribe(async (data) => {
                if (!data.error) {
                  this.load();
                  const toast = await this.toastCtrl.create({
                    message: this.translate.instant(
                      "Plano Cancelado com Sucesso"
                    ),
                    duration: 3000,
                  });

                  toast.present();
                } else {
                  const toast = await this.toastCtrl.create({
                    message: this.translate.instant(data.message),
                    duration: 3000,
                  });

                  toast.present();
                }
              });
          },
        },
      ],
    });
    alert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async parcelas(plano: any) {
    const modalPage = await this.modalCtrl.create({
      component: ContribuicoesMinhasParcelasPage,
      componentProps: { plano: plano },
    });
    modalPage.present();
  }
}
